import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AnnotationColor } from '../../types/annotation-color';
import { AnnotationTool } from '../../types/annotation-tool';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { NgIf, NgFor } from '@angular/common';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
    selector: 'app-annotation-controls',
    templateUrl: './annotation-controls.component.html',
    styleUrls: ['./annotation-controls.component.scss'],
    standalone: true,
    imports: [
        ButtonDirective,
        TooltipDirective,
        SvgComponent,
        NgIf,
        NgFor,
        ContextMenuComponent,
        ButtonMenuItemComponent,
        LoadingIndicatorComponent,
        TranslatePipe,
    ],
})
export class AnnotationControlsComponent implements OnInit {
  @Output() onSwitchTool: EventEmitter<AnnotationTool> = new EventEmitter();
  @Output() onSwitchColor: EventEmitter<AnnotationColor> = new EventEmitter();
  @Output() onHistoryChange: EventEmitter<'undo' | 'redo'> = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Input() canUndo: boolean;
  @Input() canRedo: boolean;
  tool: AnnotationTool = 'polygon';
  color: AnnotationColor = 'blue';
  colors: AnnotationColor[] = ['blue', 'green', 'yellow', 'red'];
  tools: AnnotationTool[] = ['polygon', 'arrow', 'line', 'oval', 'rect'];
  sending = false;
  shortcuts = {
    blue: 'B',
    green: 'G',
    yellow: 'Y',
    red: 'R',
    polygon: 'D',
    arrow: 'A',
    line: 'L',
    oval: 'O',
    rect: 'S',
  };
  bigScreen: boolean;

  @HostListener('window:keyup', ['$event']) keyUpEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') this.onClose.emit(true);

    if (event.key === 'r') {
      this.switchColor('red');
      this.analytics.reportKeyboardShortcut('color-red', 'annotation-controls');
    }
    if (event.key === 'g') {
      this.switchColor('green');
      this.analytics.reportKeyboardShortcut('color-green', 'annotation-controls');
    }
    if (event.key === 'b') {
      this.switchColor('blue');
      this.analytics.reportKeyboardShortcut('color-blue', 'annotation-controls');
    }
    if (event.key === 'y') {
      this.switchColor('yellow');
      this.analytics.reportKeyboardShortcut('color-yellow', 'annotation-controls');
    }

    if (event.key === 'a') {
      this.switchTool('arrow');
      this.analytics.reportKeyboardShortcut('tool-arrow', 'annotation-controls');
    }
    if (event.key === 'o') {
      this.switchTool('oval');
      this.analytics.reportKeyboardShortcut('tool-oval', 'annotation-controls');
    }
    if (event.key === 'l') {
      this.switchTool('line');
      this.analytics.reportKeyboardShortcut('tool-line', 'annotation-controls');
    }
    if (event.key === 'd') {
      this.switchTool('polygon');
      this.analytics.reportKeyboardShortcut('tool-polygon', 'annotation-controls');
    }
  }

  @HostListener('window:resize', ['$event'])
  winResize() {
    this.bigScreen = window.innerWidth > 1100;
  }

  constructor(private analytics: AnalyticsService) {}

  ngOnInit(): void {
    this.bigScreen = window.innerWidth > 1100;
  }

  switchColor(color: AnnotationColor) {
    this.color = color;
    this.onSwitchColor.emit(color);
  }

  switchTool(tool: AnnotationTool) {
    this.tool = tool;
    this.onSwitchTool.emit(tool);
  }

  done() {
    this.sending = true;
    this.onClose.emit(true);
  }
}
